// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3rNBr","smallWrapper":"style_smallWrapper__2yY8E"};